var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47.11,15.83L33.09.49c-.6-.65-1.62-.65-2.22,0l-14.03,15.34c-.88.96-.2,2.52,1.11,2.52h7.22v37.53c0,.85.69,1.54,1.54,1.54h10.53c.85,0,1.54-.69,1.54-1.54V18.35h7.22c1.31,0,1.99-1.55,1.11-2.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m83.16,84.17l-14.03,15.34c-.6.65-1.62.65-2.22,0l-14.03-15.34c-.88-.96-.2-2.52,1.11-2.52h7.22v-37.53c0-.85.69-1.54,1.54-1.54h10.53c.85,0,1.54.69,1.54,1.54v37.53h7.22c1.31,0,1.99,1.55,1.11,2.52Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/SortIcon.6c1f5f774afd7abde954466305288766.svg";
export { ForwardRef as ReactComponent };